import { Grid, Tooltip} from "@mui/material";

export function getTemplateStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'businessid',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'You must enter title',
            required:true,
            fieldtype:'string'
        },
        assetid:{
            name:'assetid',
            label:'Asset Id',
            value:'',
            error:false,
            errorMessage:'You must enter Asset Id',
            required:true,
            fieldtype:'ID'
        },
        assetname:{
            name:'assetname',
            label:'Asset Name',
            value:'',
            error:false,
            errorMessage:'You must enter Asset Name',
            required:true,
            fieldtype:'string'
        },
        assetpath:{
            name:'assetpath',
            label:'Asset Path',
            value:'',
            error:false,
            errorMessage:'You must enter Asset Path',
            required:true,
            fieldtype:'string'
        },
        campaigntext:{
            name:'campaigntext',
            label:'Campaign Text',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'title', width:150 },
        { field: 'assetname', headerName: 'Asset Name', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['assetid']:{
          ...formValues['assetid'],
          value:data.assetid,
        },['assetname']:{
          ...formValues['assetname'],
          value:data.assetname,
        },['assetpath']:{
          ...formValues['assetpath'],
          value:data.assetpath,
        },['campaigntext']:{
          ...formValues['campaigntext'],
          value:data.campaigntext,
        },
      })
}